import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {DestroyComponent} from '../destroy/destroy.component';
import {MenuDropdownComponent} from '../menu-dropdown/menu-dropdown.component';
import {environment} from '../../../environments/environment';
import {takeUntil} from 'rxjs/operators';
import {ModulTozsamosciService} from '../../auth-lib/src/lib/modul-tosamosci/services/modul-tozsamosci-service/modul-tozsamosci.service';
import { BellNotificationService } from 'src/app/services/bell-notification.service';
import { GoNotification, UrlGoNotification } from 'src/app/models/go-notification.model';

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent extends DestroyComponent  implements OnInit{
  @ViewChild(MenuDropdownComponent, {static: true}) dropdown: MenuDropdownComponent;
  @Output() collapseStateChange: EventEmitter<void> = new EventEmitter<void>();

  collapse = true;
  isLogged: boolean;
  userName: string;
  displayName: string;
  showUserName: boolean;

  portalUrl = environment.portalUrl;
  portalUrlPow = `${environment.portalUrl}/powiadomienia`;

  constructor(
    private router: Router,
    private mtService: ModulTozsamosciService,
    private notificationPrsService: BellNotificationService,
    ) {
    super();
    router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isLogged = this.mtService.isAuthenticated();
      }
    });
  }

  ngOnInit(): void {
    this.notificationPrsService.setUrlGoNotification({
      urlDefault: this.portalUrlPow,
      nodes: [
        {modul: 'EKRS', url: `${environment.apkKrsUrl}/moje-sprawy/powiadomienia`} as UrlGoNotification,
        {modul: 'NEWSLETTER', url: '/powiadomienia', isReload: true} as UrlGoNotification,
      ]
    } as GoNotification);
    
    this.isLogged = this.mtService.isAuthenticated();
    if(this.isLogged) {
      this.displayName = this.mtService.getDispayName();
      this.userName = this.mtService.getLoggedDispayName();
      this.showUserName = this.userName && this.displayName != this.userName;
    }
  }

  setCollapseState(): void {
    this.collapse = !this.collapse;
    this.collapseStateChange.emit();
  }

  toggleDropdown(event: MouseEvent, target): void {
    this.dropdown.toggle(event, target);
  }

  navigateToUrl(url: string) {
    if (url) {
      this.router.navigate([url]);
    }
  }

  login() {
    this.mtService.initLoginFlow();
    this.isLogged = this.mtService.isAuthenticated();
  }

  logout(): void {
    this.mtService.logOut();
    this.isLogged = this.mtService.isAuthenticated();
  }

  settings(): void {
    const url = environment.mt_userProfileEndpoint;
    const backUrlIndex = url?.indexOf('backUrl');
    if (backUrlIndex > -1) {
      window.location.href = url;
    } else {
      const result = confirm('Ten odnośnik otworzy nową kartę przeglądarki. Czy chcesz to zrobić?');
      if (result === true) {
        window.open(url, '_blank');
      }
    }
  }

  initOptions(): {label: string, action: () => void}[]{
    return [
      {
        label: 'Ustawienia',
        action: this.settings
      },
      {
        label: 'Wyloguj',
        action: this.logout
      }
    ];
  }

}
